import BrowserWindow from '@zachleat/browser-window';
import { HeadingAnchors } from '@zachleat/heading-anchors';
import { ProgressiveShareButton } from 'progressive-share-button';

ProgressiveShareButton();

// Article URL to clipboard
const shareButton = document.getElementsByClassName('share__copy')[0];
if (shareButton) {
  const linkText = document.getElementsByClassName('share__copy__text')[0];
  const icon = document.getElementsByClassName('share__copy__button')[0];

  shareButton.addEventListener('click', async (e) => {
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(linkText.textContent);

      // Make the icon green
      icon.classList.add('share__copy__button--active');

      const iconUse = icon.querySelector('use');

      setIcon(iconUse, '#clipboard--confirmed');

      setTimeout(() => {
        icon.classList.remove('share__copy__button--active');
        setIcon(iconUse, '#clipboard');
      }, 4000);
    } catch (err) {
      console.error(err.name, err.message);
    }
  });

}

const setIcon = (iconUse, iconRef) => {
  const href = iconUse.getAttribute('href');
  const newHref = href.replace(/#.*$/, iconRef);
  iconUse.setAttribute('href', newHref);
}
